import { BaySearchEnum } from "../Enums/bay-search-enum";
import { ArcGisBayColumn } from "./arcgis-bay-column.model";
export const BaysSearchColumnToArcGisColumnBaysLookup = new Map([
    [BaySearchEnum.tradingSiteDescription, ArcGisBayColumn.TradingSiteDescription],
    [BaySearchEnum.tradingSiteTown, ArcGisBayColumn.TradingSiteTown],
    [BaySearchEnum.tradingSiteStatus, ArcGisBayColumn.TradingSiteStatus],
    [BaySearchEnum.status, ArcGisBayColumn.Status],
    [BaySearchEnum.size, ArcGisBayColumn.Size],
]);
